<template>
    <div>

        <Row style="margin-top: 10px">
         <Col span="24">
              <div class="approvedCheckbox">
                <label class="fancy-checkbox" style="font-size: 16px;">
                  <input v-model="pickupConfirmation" type="checkbox" />
                  <i class="fal fa-check-circle unchecked"></i>
                  <i class="fas fa-check-circle checked" style="color: #2d8cf0;"></i>
                  <span style="margin-left: 10px;">Pickup Confirmation</span>
                </label>
              </div>
         </Col>
            <Col span="24">
              <div class="approvedCheckbox">
                <label class="fancy-checkbox" style="font-size: 16px;">
                  <input v-model="orderReadiness" type="checkbox" />
                  <i class="fal fa-check-circle unchecked"></i>
                  <i class="fas fa-check-circle checked" style="color: #2d8cf0;"></i>
                  <span style="margin-left: 10px;">Order Readiness</span>
                </label>
              </div>
            </Col>
            <Col span="24">
              <div class="approvedCheckbox">
                <label class="fancy-checkbox" style="font-size: 16px;">
                  <input v-model="islrReady" type="checkbox" />
                  <i class="fal fa-check-circle unchecked"></i>
                  <i class="fas fa-check-circle checked" style="color: #2d8cf0;"></i>
                  <span style="margin-left: 10px;">LR Ready</span>
                </label>
              </div>
            </Col>
            <Col span="24">

              <div class="approvedCheckbox">
                <label class="fancy-checkbox" style="font-size: 16px;">
                  <input v-model="isEmailSent" type="checkbox" />
                  <i class="fal fa-check-circle unchecked"></i>
                  <i class="fas fa-check-circle checked" style="color: #2d8cf0;"></i>
                  <span style="margin-left: 10px;">Confirmation Email</span>
                </label>
              </div>
            </Col>

            <Col span="24" align="left" style="margin-top: 15px">
                <Button type="primary" @click="updateOrderDetail" ghost>Update</Button>
                <Button type="primary" style="margin-left: 15px;" @click="updateOrderDetail_UpdateOrder" ghost>Update & Next</Button>
            </Col>
        </Row>

    </div>
</template>

<script>
import {GET_ORDER_DETAIL} from '../../graphql/queries/OrderDetails'
import {SUBSCRIBE_ORDER_DETAIL} from '../../graphql/subscription/orderDetails'
import {UPDATE_ORDER_DETAIL_UPDATE_ORDER, UPDATE_ORDER_DETAIL} from '../../graphql/mutations/orderDetails'
import {generateUUID} from "../../Constants/Constant";
    export default {
        apollo: {
            orderDetails: {
                query: GET_ORDER_DETAIL,
                variables() {
                    return {
                        orderId: this.orderId
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_ORDER_DETAIL,
                    variables() {
                        return {
                            orderId: this.orderId
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        if(subscriptionData.data.orderDetails.length){
                            this.orderDetailId = subscriptionData.data.orderDetails[0].id;
                            this.orderDetails = subscriptionData.data.orderDetails[0]
                            this.initializeData(subscriptionData.data.orderDetails[0])
                        }else{
                            this.orderDetailId = '';
                        }
                    },
                },
                // fetchPolicy: 'no-cache',
                result({data, loading}) {
                    if (!loading) {
                        if(data.orderDetails.length){
                            this.orderDetailId = data.orderDetails[0].id;
                            this.orderDetails = data.orderDetails[0]
                            this.initializeData(data.orderDetails[0])
                        }else{
                            this.orderDetailId = '';
                        }
                    }
                }
            }
        },
        name: "ApprovalForm",
        props:['orderId'],
        inject: ["setManageOrderDrawer"],
        data: function(){
            return{
                mutation_UPDATE_ORDER_DETAIL_UPDATE_ORDER: UPDATE_ORDER_DETAIL_UPDATE_ORDER,
                mutation_UPDATE_ORDER_DETAIL: UPDATE_ORDER_DETAIL,
                pickupConfirmation: false,
                orderReadiness: false,
                islrReady: false,
                isEmailSent: false,
                orderDetailId: '',
                orderDetails:''
            }
        },
        methods:{
            initializeData(orderDetail){
                this.pickupConfirmation = orderDetail.pickupConfirmation==='Done'?true:false;
                this.orderReadiness = orderDetail.orderReadiness.isOrderReady?true:false;
                this.islrReady = orderDetail.lrObject.islrReady?true:false;
                this.isEmailSent = orderDetail.lrObject.isEmailSent?true:false;
            },
            async updateOrderDetail(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_ORDER_DETAIL,
                    variables: {
                        id: generateUUID(),
                        orderReadiness: {
                            isOrderReady: this.orderReadiness,
                            pickupDate: ''
                        },
                        lrObject: {
                            islrReady: this.islrReady,
                            isEmailSent: this.isEmailSent
                        },
                        pickupConfirmation: this.pickupConfirmation?'Done':'Awaiting',
                        pickupPoint: {
                            pickupPartyName: this.orderDetails.pickupPoint.pickupPartyName,
                            pickupPartyId: this.orderDetails.pickupPoint.pickupPartyId,
                            mobile: this.orderDetails.pickupPoint.mobile?this.orderDetails.pickupPoint.mobile:'',
                            email: this.orderDetails.pickupPoint.email?this.orderDetails.pickupPoint.email:'',
                            add1: this.orderDetails.pickupPoint.add1,
                            add2: this.orderDetails.pickupPoint.add2,
                            area: this.orderDetails.pickupPoint.area,
                            pincode: this.orderDetails.pickupPoint.pincode,
                            city: this.orderDetails.pickupPoint.city,
                            state: this.orderDetails.pickupPoint.state
                        },
                        dropPoint: {
                            dropPartyName: this.orderDetails.dropPoint?
                                this.orderDetails.dropPoint.dropPartyName:'',
                            dropPartyId: this.orderDetails.dropPoint?
                                this.orderDetails.dropPoint.dropPartyId:'',
                            mobile: this.orderDetails.dropPoint && this.orderDetails.dropPoint.mobile?
                                this.orderDetails.dropPoint.mobile:'',
                            email: this.orderDetails.dropPoint && this.orderDetails.dropPoint.email?
                                this.orderDetails.dropPoint.email:'',
                            add1: this.orderDetails.dropPoint?
                                this.orderDetails.dropPoint.add1:'',
                            add2: this.orderDetails.dropPoint?
                                this.orderDetails.dropPoint.add2:'',
                            area: this.orderDetails.dropPoint?
                                this.orderDetails.dropPoint.area:'',
                            pincode: this.orderDetails.dropPoint?
                                this.orderDetails.dropPoint.pincode:'',
                            city: this.orderDetails.dropPoint?
                                this.orderDetails.dropPoint.city:'',
                            state: this.orderDetails.dropPoint?
                                this.orderDetails.dropPoint.state:''
                        },
                        orderId: this.orderId,
                        orderDetailId: this.orderDetailId,
                        internalstatus: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a'
                    }
                })
                if(response.data){
                    this.$Message.success('Order Detail updated successfully!');
                    this.setManageOrderDrawer(false)
                }
            },
            async updateOrderDetail_UpdateOrder(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_ORDER_DETAIL_UPDATE_ORDER,
                    variables: {
                        id: generateUUID(),
                        orderReadiness: {
                            isOrderReady: this.orderReadiness,
                            pickupDate: ''
                        },
                        lrObject: {
                            islrReady: this.islrReady,
                            isEmailSent: this.isEmailSent
                        },
                        pickupConfirmation: this.pickupConfirmation?'Done':'Awaiting',
                        pickupPoint: {
                            pickupPartyName: this.orderDetails.pickupPoint.pickupPartyName,
                            pickupPartyId: this.orderDetails.pickupPoint.pickupPartyId,
                            mobile: this.orderDetails.pickupPoint.mobile?this.orderDetails.pickupPoint.mobile:'',
                            email: this.orderDetails.pickupPoint.email?this.orderDetails.pickupPoint.email:'',
                            add1: this.orderDetails.pickupPoint.add1,
                            add2: this.orderDetails.pickupPoint.add2,
                            area: this.orderDetails.pickupPoint.area,
                            pincode: this.orderDetails.pickupPoint.pincode,
                            city: this.orderDetails.pickupPoint.city,
                            state: this.orderDetails.pickupPoint.state
                        },
                        orderId: this.orderId,
                        orderDetailId: this.orderDetailId,
                        internalstatus: '154dcbf5-2ee8-b60d-9f0d-4709944337bd',  //Change internalStatusId to VehicleAssignment
                        rejectionNote: ''
                    }
                })
                if(response.data){
                    this.$Message.success('Order Detail updated successfully!');
                    this.setManageOrderDrawer(false)
                }
            },
        }
    }
</script>

<style scoped>
  .fancy-checkbox input[type="checkbox"],
  .fancy-checkbox .checked {
    display: none;
  }

  .fancy-checkbox input[type="checkbox"]:checked ~ .checked
  {
    display: inline-block;
  }

  .fancy-checkbox input[type="checkbox"]:checked ~ .unchecked
  {
    display: none;
  }
  .approvedCheckbox{
    padding: 15px 5px;
    border-bottom: 1px solid #cdcdcd ;
  }
</style>
